import { Typography, Button } from "components/atoms";
import { Modal } from "../Modal";
import { CloseIcon } from "components/atoms/Icon";
import "./index.scss";

interface IProps {
  handleOnClose: () => void;
  contentObjectType?: string|null;
  isOpen: boolean;
  theme: "light" | "dark";
  pageNo?: number;
  filter?: any;
  isFetching?:boolean;
  handleRefresh:()=>void;
}

export const RefreshModal = ({
  handleOnClose,
  contentObjectType,
  isOpen,
  theme,
  isFetching,
  handleRefresh,
}: IProps) => {
  return (
    <Modal isOpen={isOpen} onClose={handleOnClose} theme={theme} style="refresh-modal-overlay">
      <div className="refresh-modal-wrapper">
      <div className="refresh-modal-header">
        <div className="refresh-modal-header-typography">
          <div className="title-typography-wrapper">
            <Typography
              label="Refresh Request"
              variant="h6Medium"
              styles="refresh-modal-header-typography-custom-style"
            />
          </div>
        </div>
        <div
          className="refresh-modal-header-close-icon"
          onClick={handleOnClose}
        >
          <CloseIcon theme={theme} />
        </div>
      </div>
        <div className="refresh-modal-body">
          <div className="refresh-modal-description-section">
            <Typography
              label={`Click Refresh after you finish your ${contentObjectType || "lesson"}`}
              variant="h6Medium"
            />
          </div>
          <div className="refresh-modal-button-section">
            <Button
              icon={false}
              label="Cancel"
              type="online"
              onClick={handleOnClose}
            />
            <Button
              icon={false}
              label="Refresh"
              type="score"
              onClick={handleRefresh}
              isLoading={isFetching}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};
